import { useState, useCallback } from "react";
import JSZip from "jszip";
import { parseMenoraFiles, isMenoraContents } from "../parsers/menoraParser";

export function useMenoraBatchLoader() {
  const [busy, setBusy] = useState(false);

  const loadFiles = useCallback(async (files, existingClients) => {
    setBusy(true);
    const results = [];

    const allFiles = Array.from(files);
    
    for (const zipFile of allFiles) {
      try {
        const zip = await JSZip.loadAsync(zipFile);
        const entries = await Promise.all(
          Object.values(zip.files)
            .filter(e => !e.dir)
            .map(async e => ({
              name: e.name.replace(/.*\//, ''),
              content: await e.async('arraybuffer'),
            }))
        );

        if (isMenoraContents(entries)) {
          const parsed = parseMenoraFiles(entries);
          
          const matched = [];
          const unmatched = [];

          for (const member of parsed.members) {
            const existing = existingClients.find(c => c.clientId === member.taz);
            if (existing) {
              matched.push({ ...member, existingClientId: existing.id, existingName: existing.clientName });
            } else {
              const newName = [member.firstName, member.lastName].filter(Boolean).join(' ');
              unmatched.push({ ...member, newName });
            }
          }

          // Try to extract date from filename like 10_06_2026
          let defaultReportMonth = "";
          const m = zipFile.name.match(/(\d{2})_(\d{4})/);
          if (m) {
              let mm = parseInt(m[1], 10);
              let yyyy = parseInt(m[2], 10);
              mm -= 1;
              if (mm === 0) { mm = 12; yyyy -= 1; }
              defaultReportMonth = `${yyyy}-${String(mm).padStart(2, "0")}`;
          } else {
              const mm = String(new Date().getMonth() + 1).padStart(2, "0");
              defaultReportMonth = `${new Date().getFullYear()}-${mm}`;
          }

          results.push({
            fileName: zipFile.name,
            defaultReportMonth,
            matched,
            unmatched,
            totalBalance: parsed.members.reduce(
              (sum, m) => sum + m.funds.reduce((s, f) => s + (f.balance || 0), 0), 0
            ),
          });
        } else {
          results.push({ fileName: zipFile.name, error: 'הקובץ אינו מכיל נתוני מנורה תקינים (חסרים P/N)' });
        }
      } catch (err) {
        results.push({ fileName: zipFile.name, error: err.message });
      }
    }

    setBusy(false);
    return results;
  }, []);

  return { loadFiles, busy };
}
